<template>
  <div>
    <div id="bg" :style="popup_style"></div>
    <div id="wrap">
      <ul class="blind">
        <li>
          <a href="#contents">본문 바로가기(Skip Contents)</a>
        </li>
      </ul>

      <div id="container" ref="container">
        <section id="contents">
          <div class="loading_animate">
            <div class="aniArea">
              <h1>
                <img src="@/assets/img/login_logo.png" alt="welive" class="logo" />
                <img src="@/assets/img/login_logo_on.png" alt="on" class="logo2" />
              </h1>
              <h3>
                <span>Start</span>
                <span>your</span>
                <span>weliveon</span>
              </h3>
              <p>소통, 그 이상의 즐거움</p>
              <span class="arrow"></span>
            </div>

            <div class="loginWrap">
              <form onsubmit="return false" method="get">
                <fieldset>
                  <legend>login</legend>
                  <!-- 
                                단일 인풋 일 경우
                  -->
                  <div class="login" style="display: block;">
                    <div class="inputarea">
                      <div class="inputbox">
                        <input
                          type="text"
                          class="key"
                          :placeholder="default_msg"
                          v-model="default_info"
                          maxlength="10"
                        />
                      </div>

                      <div class="inputbox" v-if="att_info.dept">
                        <input
                          v-model="user_dept"
                          :class="error_dept"
                          type="text"
                          placeholder="소속을 입력해주세요."
                        />
                      </div>

                      <div class="inputbox" :class="error_nick" v-if="att_info.nick">
                        <input
                          v-model="user_nick"
                          :class="error_nick"
                          type="text"
                          placeholder="닉을 입력해주세요."
                        />
                      </div>

                      <div class="inputbox" v-if="att_info.name">
                        <input
                          v-model="user_name"
                          type="text"
                          :class="error_name"
                          placeholder="이름을 입력해주세요"
                        />
                      </div>

                      <div class="inputbox" v-if="att_info.dept_no">
                        <input
                          v-model="user_dept_no"
                          :class="error_dept_no"
                          type="text"
                          placeholder="사번/학번을 입력해주세요."
                        />
                      </div>

                      <div class="inputbox" v-if="att_info.email">
                        <input
                          v-model="user_email"
                          type="text"
                          :class="error_email"
                          placeholder="이메일 주소를 입력해주세요."
                        />
                      </div>

                      <div class="inputbox" v-if="att_info.hp">
                        <input
                          v-model="user_hp"
                          type="text"
                          :class="error_hp"
                          placeholder="핸드폰 번호를 입력해주세요."
                        />
                      </div>

                      <div class="inputbox" v-if="hasPassword">
                        <input
                          v-model="mypassword"
                          type="text"
                          :class="error_password"
                          placeholder="비밀번호를 확인해주세요."
                        />
                      </div>
                    </div>

                    <div class="login_chk">
                      <a href="#" class="agreeBtn" title="개인정보 관련 동의" @click="toggle_privacy">
                        <img :src="privacy_status_img" alt="개인정보 관련 동의" />개인정보 관련 동의
                      </a>
                    </div>
                    <button type="submit" @click="submit">ENTER</button>
                  </div>

                  <!-- login -->
                </fieldset>
              </form>
            </div>
            <!-- loginWrap -->

            <div class="agreePop" :style="popup_style">
              <div class="agreeTitle">
                개인정보 관련 동의
                <a href="#" class="close" title="닫기" @click.prevent="closePopup">
                  <img src="@/assets/img/popClose.png" alt="닫기" />
                </a>
              </div>
              <!-- agreeTitle -->
              <div class="agreeCon">
                <dl>
                  <!-- 
                                아코디언 메뉴 펼치기 전
                                <dt>
                                펼쳐진 경우 on 클래스 추가
                                <dt class="on">
                                    
                  -->
                  <dt :class="auth1Class">
                    <div class="login_chk necessary">
                      <input type="checkbox" name id="agree1" @click="accpet_privacy_func" />
                      <label for="agree1">필수</label>
                    </div>
                    <a href="#" @click.prevent="fold_agreed_privacy_func">
                      <h3>개인정보 수집 및 이용에 동의합니다.</h3>
                      <img src="@/assets/img/popArrow.png" alt="열기/닫기" />
                    </a>
                  </dt>
                  <dd v-if="toggle_step1window">
                    <pre>{{service_privacy_text}}
                    </pre>
                  </dd>
                  <template v-if="hasPrivacy">
                    <dt :class="auth2Class">
                      <div class="login_chk">
                        <input type="checkbox" name id="agree2" @click="accpet_privacy2_func" />
                        <label for="agree2">선택</label>
                      </div>
                      <a href="#" @click.prevent="fold_agreed_privacy2_func">
                        <h3>개인정보 제3자 제공에 동의합니다.</h3>
                        <img src="@/assets/img/popArrow.png" alt="열기/닫기" />
                      </a>
                    </dt>
                    <dd v-if="toggle_step2window">
                      <pre>
                      {{privacyText}}
                      </pre>
                    </dd>
                  </template>
                </dl>
              </div>
              <!-- agreeCon -->
            </div>
            <!-- agreePop -->
          </div>
          <!-- loading_animate -->
        </section>
        <!-- //contents -->
      </div>
      <!-- //container -->
    </div>
    <!-- //wrap -->
  </div>
</template>

<script>
import router from "@/router";
import { Constant } from "@/utils/const";
import sideMixin from "@/components/SideMixin";
export default {
  mixins: [sideMixin],
  created() {
    //todo  transform clsid if param has shorten key

    let clsid = this.$route.params.clsid;

    let isshorten = /^\d+$/.test(clsid);

    if (isshorten) {
      let that = this;
      let url = `${Constant.ShortenApi}/id/${clsid}`;
      this.$axios.get(url).then((resp) => {
        clsid = resp.data.short_url;
        that.$store.dispatch("setClassInfo", clsid);
        localStorage.setItem("clsid", clsid);
        if (localStorage.getItem(`default_info_${clsid}`) !== null) {
          //todo: socket을 다시 맷어야함.
          router.replace("/main");
        }
      });
    } else {
      this.$store.dispatch("setClassInfo", clsid);
      if (localStorage.getItem(`default_info_${clsid}`) !== null) {
        //todo: socket을 다시 맷어야함.
        router.replace("/main");
      }
    }

    //get privacy text  for next
    let privacy_url = `${Constant.ServicePrivacy}?board_flag=4`;
    let $this = this;
    this.$axios.get(privacy_url).then((resp) => {
      let text = resp.data.rows[0].board_content;
      this.service_privacy_text = text;
    });
  },
  computed: {
    default_msg() {
      return `사용하실 ${this.att_info.default_info}을 입력하세요`;
    },
    privacy_status_img: function () {
      if (this.accept1) {
        return require("@/assets/img/login_check_on.png");
      } else {
        return require("@/assets/img/login_check.png");
      }
    },
    att_info: function () {
      let obj = this.$store.getters.getAttInfo.default_info;
      return this.$store.getters.getAttInfo;
    },
    popup_style: function () {
      if (this.opened_privacy) {
        return "display:block;";
      } else {
        return "display:none;";
      }
    },

    hasPassword() {
      return this.$store.state.clsMeta.password != null ? true : false;
    },
    hasPrivacy() {
      return this.$store.state.clsMeta.privacy_collect != null ? true : false;
    },

    privacyText() {
      let company = this.$store.state.clsMeta.privacy_collect;
      let infos = "";

      if (this.att_info.dept) infos += "소속, ";
      if (this.att_info.nick) infos += "닉네임, ";
      if (this.att_info.name) infos += "이름, ";
      if (this.att_info.dept_no) infos += "사번/소속, ";
      if (this.att_info.email) infos += "이메일, ";
      if (this.att_info.hp) infos += "전화번호, ";

      if (infos.length > 2) {
        infos = infos.substring(0, infos.length - 2);
      }

      let str = `
개인정보 제3자 제공 관련 

  - 개인정보를 제공받는 자 : ${company}
  - 개인정보를 제공받는 자의 개인정보 이용목적 : 
    마케팅 / 광고에 활용 
  - 제공하는 개인정보의 항목 : 
    ${infos}
  - 개인정보를 제공받는 자의 개인정보 보유 및 이용기간 : 
    수집일로부터 1년(고객동의 철회 시, 지체없이 파기) 
  - 개인정보 제3자 제공 동의 거부 시, 설문 및 일부 서비스 정보 제공에 제한이 있을 수 있습니다.       
      `;

      return str;
    },
    auth1Class() {
      return this.toggle_step1window ? "on" : "off";
    },
    auth2Class() {
      return this.toggle_step2window ? "on" : "off";
    },
  },
  data: function () {
    return {
      agreed_privacy: false,
      opened_privacy: false,
      default_info: null,
      toggle_step1window: true,
      toggle_step2window: false,
      accept1: false,
      accept2: false,

      user_name: null,
      user_dept: null,
      user_dept_no: null,
      user_hp: null,
      user_email: null,
      user_nick: null,

      error_name: "",
      error_hp: "",
      error_dept: "",
      error_dept_no: "",
      error_email: "",
      error_nick: "",
      error_password: "",

      mypassword: "",
      service_privacy_text: "",
    };
  },
  methods: {
    toggle_privacy: function () {
      this.opened_privacy = true;
    },
    fold_agreed_privacy_func: function () {
      // this.toggle_step1window = !this.toggle_step1window;

      this.toggle_step1window = true;
      this.toggle_step2window = false;
    },

    fold_agreed_privacy2_func: function () {
      // this.toggle_step2window = !this.toggle_step2window;

      this.toggle_step1window = false;
      this.toggle_step2window = true;
    },

    agreed_privacy_func: function () {
      this.opened_privacy = false;
      this.agreed_privacy = true;
    },
    accpet_privacy_func() {
      this.accept1 = !this.accept1;

      if (this.accept1 && !this.hasPrivacy) {
        this.opened_privacy = false;
      }
    },
    accpet_privacy2_func() {
      this.accept2 = !this.accept2;
    },

    closePopup() {
      this.opened_privacy = false;
    },
    submit: function () {
      //todo: 유효성 체크
      //todo: 디비저장
      //todo: 소켓에 동일한 아이디 있는지 확인후 저장
      let pass = true;
      if (this.default_info === null) {
        // alert(this.att_info.default_info + "가 필요합니다");
        pass = false;
      }

      if (this.att_info.name && this.user_name == null) {
        this.error_name = "empty_error";
        pass = false;
      }
      if (this.att_info.dept && this.user_dept == null) {
        this.error_dept = "empty_error";
        pass = false;
      }

      if (this.att_info.dept_no && this.user_dept_no == null) {
        this.error_dept_no = "empty_error";
        pass = false;
      }

      if (this.att_info.hp && this.user_hp == null) {
        this.error_hp = "empty_error";
        pass = false;
      }

      // if (this.user_hp != null) {
      //   var regExp = /^\d{3}-\d{3,4}-\d{4}$/;
      //   if (!regExp.test(this.user_hp)) {
      //     alert("핸드폰번호를  확인해주세요");
      //     this.error_email = "empty_error";
      //     this.user_hp = null;
      //     pass = false;
      //   }
      // }

      if (this.att_info.email && this.user_email == null) {
        this.error_email = "empty_error";
        pass = false;
      }

      if (this.user_email != null) {
        var regExp = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
        if (!regExp.test(this.user_email)) {
          // alert("이메일을 확인해주세요");
          this.error_email = "empty_error";
          this.user_email = null;
          pass = false;
        }
      }

      if (this.att_info.nick && this.user_nick == null) {
        this.error_nick = "empty_error";
        pass = false;
      }
      if (this.hasPassword) {
        if (this.mypassword !== this.$store.state.clsMeta.password) {
          // alert("패스워드를 확인해주세요");
          this.error_password = "empty_error";
          this.mypassword = null;
          pass = false;
        }
      }

      if (pass) {
        let payload_out = {
          default_info: this.default_info,
          name: this.user_name,
          email: this.user_email,
          nick: this.user_nick,
          dept: this.user_dept,
          hp: this.user_hp,
          dept_no: this.user_dept_no,
          classroom_id: this.$store.state.clsid,
          privacy: this.accept2,
          etc: navigator.userAgent,
        };

        if (!this.accept1) {
          alert("개인정보취급동의가 필요합니다");
          return;
        }

        this.$store.dispatch("saveUserToPersist", payload_out);
      } else {
        alert("입력값을 확인해주세요");
      }
    },
  },
};
</script>


<style lang="scss" scoped>
.loading_animate {
  text-align: center;
  min-height: 100vh;
  background: #2f2f30;
  position: relative;
  width: 100%;
  overflow: hidden;
}
.aniArea {
  position: relative;
  min-height: 620px;
  width: 80%;
  margin: 0 auto;
  position: absolute;
  left: 10%;
  top: 0;
}
.loading_animate h1 {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: inline-block;
  vertical-align: top;
  display: inline-block;
  opacity: 0;
  animation: logo 3s ease 0.3s;
  animation-fill-mode: forwards;
  font-size: 0;
  text-align: left;
  width: 147px;
}
@keyframes logo {
  0% {
    top: 50%;
    opacity: 1;
    width: 147px;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  30% {
    opacity: 1;
    top: 50%;
    width: 147px;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  60% {
    opacity: 0.2;
    top: 30%;
    left: 50%;
    width: 100px;
    transform: translate(-50%, -50%);
  }
  100% {
    opacity: 0.2;
    top: 15%;
    left: 0%;
    width: 100px;
    transform: translate(0%, -50%);
  }
}

.loading_animate .aniArea h1 img {
  opacity: 0;
}
.loading_animate .aniArea h1 .logo {
  width: 70%;
  animation: logo_d 1s ease 0.2s;
  animation-fill-mode: forwards;
}
.loading_animate .aniArea h1 .logo2 {
  width: 25%;
  margin-top: 5%;
  margin-left: 3%;
  animation: logo_d2 1s ease 0.2s;
  animation-fill-mode: forwards;
}
@keyframes logo_d {
  0% {
    opacity: 0;
    margin-left: -30px;
  }
  100% {
    opacity: 1;
    margin-left: 0px;
  }
}
@keyframes logo_d2 {
  20% {
    opacity: 0;
    margin-left: -30px;
  }
  100% {
    opacity: 1;
    margin-left: 3%;
  }
}

.loading_animate .aniArea h3 {
  position: relative;
  display: inline-block;
  color: #ffffff;
  font-size: 38px;
  font-weight: 900;
  text-transform: uppercase;
  line-height: 1em;
  position: absolute;
  left: 50%;
  top: 42%;
  transform: translate(-50%, -50%);
  text-align: left;
  opacity: 0;
  width: 200px;
  height: 113px;
  animation: slg 2.3s ease 1.55s;
  animation-fill-mode: forwards;
}
.loading_animate .aniArea h3 span {
  display: inline-block;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%);
  font-weight: 100;
  font-family: "NotoKrB";
}
.loading_animate .aniArea h3 span:nth-child(1) {
  top: 0;
}
.loading_animate .aniArea h3 span:nth-child(2) {
  transform: translate(-50%, -50%);
}
.loading_animate .aniArea h3 span:nth-child(3) {
  bottom: 0;
  top: auto;
}

.loading_animate .aniArea h3 span:nth-child(1),
.loading_animate .aniArea h3 span:nth-child(3) {
  animation: detail 2.3s ease 1s;
  animation-fill-mode: forwards;
}
.loading_animate .aniArea h3 span:nth-child(2) {
  animation: detail2 2.3s ease 1s;
  animation-fill-mode: forwards;
}
@keyframes slg {
  0% {
    top: 42%;
    opacity: 0;
    font-size: 30px;
    transform: translate(-50%, -50%);
  }
  30% {
    opacity: 1;
    top: 42%;
    left: 50%;
    font-size: 38px;
    transform: translate(-50%, -50%);
  }
  60% {
    top: 28%;
    left: 0%;
    transform: translate(0%, -50%);
  }
  100% {
    opacity: 1;
    top: 28%;
    left: 0%;
    font-size: 38px;
    transform: translate(0%, -50%);
  }
}
@keyframes detail {
  60% {
    left: 50%;
    transform: translateX(-50%);
  }
  100% {
    left: 0%;
    transform: translateX(-0%);
  }
}
@keyframes detail2 {
  60% {
    left: 50%;
    transform: translate(-50%, -50%);
  }
  100% {
    left: 0%;
    transform: translate(0%, -50%);
  }
}
.loading_animate .aniArea p {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  font-size: 18px;
  color: #ffffff;
  font-weight: 100;
  font-family: "NotoKrL";
  opacity: 0;
  animation: slg2 2.3s ease 1.69s;
  animation-fill-mode: forwards;
  display: inline-block;
  width: 166px;
}

@keyframes slg2 {
  0% {
    top: 45%;
    opacity: 0;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  30% {
    opacity: 0;
    top: 54%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  40% {
    opacity: 1;
  }
  60% {
    top: 41%;
    left: 0%;
    transform: translate(0%, -50%);
  }
  100% {
    opacity: 1;
    top: 41%;
    left: 0%;
    transform: translate(0%, -50%);
  }
}

.loading_animate .arrow {
  position: relative;
  position: absolute;
  right: 120%;
  top: 44%;
  display: block;
  width: 125%;
  overflow: hidden;
  height: 30px;
  animation: arrow 2.3s ease 2.5s;
  animation-fill-mode: forwards;
}
.loading_animate .arrow:before,
.loading_animate .arrow:after {
  content: "";
  display: block;
  background: #00d7c0;
  height: 2px;
  position: absolute;
  right: 0;
  bottom: 0;
  border-radius: 1px;
}
.loading_animate .arrow:before {
  bottom: 0px;
  right: 0px;
  width: 100%;
}
.loading_animate .arrow:after {
  width: 22px;
  transform: rotate(45deg);
  bottom: 8px;
  right: -3px;
}

@keyframes arrow {
  0% {
    right: 120%;
  }
  100% {
    right: -12%;
  }
}

.loginWrap {
  width: 100%;
  position: relative;
  width: 80%;
  margin: 0 auto;
  text-align: left;
  animation: login 1s ease 3.8s;
  animation-fill-mode: forwards;
  opacity: 0;
  padding-top: 345.6px;
  padding-bottom: 5%;
  z-index: 2;
}
@keyframes login {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.login {
  position: relative;
  padding-top: 30px;
}
.login .error {
  color: #00d7c0;
  font-size: 14px;
  font-weight: 100;
  font-family: "NotoKrL";
  position: absolute;
  left: 0;
  top: 0;
}
.login .inputarea input {
  height: 41px;
  border: none;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  color: #ffffff;
  font-size: 14px;
  background: none;
  width: 100%;
  line-height: 41px;
  font-weight: 100;
  font-family: "NotoKrL";
}
.login .inputarea .inputbox {
  position: relative;
}
.login .inputarea .inputbox:first-child input {
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}
.login .inputarea .inputbox .chk_btn {
  height: 41px;
  border: none;
  color: #ffffff;
  font-size: 14px;
  background: none;
  width: auto;
  display: inline-block;
  vertical-align: top;
  line-height: 41px;
  font-weight: 100;
  font-family: "NotoKrL";
  position: absolute;
  right: 15px;
  top: 0;
}
.login #id::placeholder {
  color: rgba(255, 255, 255, 0.2);
  font-weight: 100;
  font-family: "NotoKrL";
}

.login_chk {
  position: relative;
  margin-top: 15px;
}
.login_chk input[type="checkbox"] {
  display: none;
  position: absolute;
  overflow: hidden;
  padding: 0;
  margin: 0;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
.agreeBtn,
.login_chk input[type="checkbox"] + label {
  position: relative;
  display: inline-block;
  cursor: pointer;
  color: #ffffff;
  font-size: 12px;
  line-height: 18px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-family: "NotoKrL";
  font-weight: 100;
}

.login_chk input[type="checkbox"] + label:before {
  content: " ";
  cursor: pointer;
  display: inline-block;
  vertical-align: top;
  width: 18px;
  height: 18px;
  background: url("../assets/img/login_check.png") no-repeat center center;
  background-size: 100%;
  margin-right: 8px;
}
.login_chk input[type="checkbox"] + label:active:before,
.login_chk input[type="checkbox"]:checked + label:active:before {
  background: url("../assets/img/login_check.png") no-repeat center center;
  background-size: 100%;
}
.login_chk input[type="checkbox"]:checked + label:before {
  background: url("../assets/img/login_check_on.png") no-repeat center center;
  background-size: 100%;
}

.login button {
  margin-top: 34px;
  text-align: center;
  width: 100%;
  border: 1px solid #00d7c0;
  color: #00d7c0;
  font-size: 16px;
  border-radius: 3px;
  line-height: 40px;
  height: 40px;
  background: none;
}

.agreeBtn img {
  width: 18px;
  margin-right: 8px;
}

/*팝업*/
.agreePop {
  display: none;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: #2e2e2e;
  width: 90%;
  overflow: hidden;
  height: 421px;
  z-index: 13;
}

.agreePop .agreeTitle {
  position: relative;
  height: 61px;
  text-align: center;
  color: #ffffff;
  font-size: 17px;
  line-height: 61px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}
.agreePop .agreeTitle a {
  position: absolute;
  width: 50px;
  height: 60px;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  display: block;
  text-align: center;
  line-height: 60px;
}
.agreePop .agreeTitle a img {
  width: 15px;
}
.agreeCon {
}
.agreeCon dl {
}
.agreeCon dt {
  position: relative;
  height: 50px;
  text-align: left;
  padding: 5%;
  font-size: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}
.agreeCon dl dt .login_chk {
  display: inline-block;
  vertical-align: top;
  margin-top: 0;
  width: 50px;
}
.agreeCon dl dt .login_chk label {
  vertical-align: top;
}
.agreeCon dl dt .login_chk input:checked + label {
  color: #00d7c0;
}
.agreeCon dl dt a {
  font-size: 13px;
  display: inline-block;
  vertical-align: top;
  color: #ffffff;
  width: calc(100% - 50px);
}
.agreeCon dl dt a h3 {
  font-size: 13px;
  color: #ffffff;
  padding-left: 5px;
}
.agreeCon dl dt a img {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  width: 15px;
  transform: rotate(180deg);
}
.agreeCon dl dt.on a img {
  transform: rotate(0deg);
}
.agreeCon dl dd {
  padding: 20px;
  color: #9c9c9c;
  font-size: 12px;
  text-align: left;
  height: 260px;
  overflow: hidden;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  background: #202020;
}
.agreeCon dl dd pre {
  overflow-y: auto;
  width: 100%;
  white-space: pre-wrap;
  height: 220px;
  padding-right: 15px;
}

.agreeCon dl dd pre::-webkit-scrollbar {
  width: 2.5px;
}
.agreeCon dl dd pre::-webkit-scrollbar-track {
  background-color: #1a1a1a;
  border-radius: 1.25px;
}
.agreeCon dl dd pre::-webkit-scrollbar-thumb {
  background: #00d7c0;
  border-radius: 1.25px;
}
.agreeCon dl dd pre::-webkit-scrollbar-thumb:hover {
  background: #00d7c0;
}
.agreeCon dl dd pre::-webkit-scrollbar-thumb:active {
  background: #808080;
}
.agreeCon dl dd pre::-webkit-scrollbar-button {
  display: none;
}
</style>